import { render } from "./ToxicologyOrderChecklistView.vue?vue&type=template&id=3bc44034"
import script from "./ToxicologyOrderChecklistView.vue?vue&type=script&lang=js"
export * from "./ToxicologyOrderChecklistView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/ToxicologyOrderChecklistView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3bc44034"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3bc44034', __exports__)) {
    console.log('reload')
    api.reload('3bc44034', __exports__)
  }
  
  module.hot.accept("./ToxicologyOrderChecklistView.vue?vue&type=template&id=3bc44034", () => {
    console.log('re-render')
    api.rerender('3bc44034', render)
  })

}


export default __exports__